export const locales = {
	patientChange: 'Changer de patient',
	status: 'Statut :',
	nir: 'NIR :',
	more: 'Plus d’informations'
};
